import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const checkboxBodyFn = /* @__PURE__ */ createRecipe('checkbox-body', {}, [])

const checkboxBodyVariantMap = {}

const checkboxBodyVariantKeys = Object.keys(checkboxBodyVariantMap)

export const checkboxBody = /* @__PURE__ */ Object.assign(memo(checkboxBodyFn.recipeFn), {
  __recipe__: true,
  __name__: 'checkboxBody',
  __getCompoundVariantCss__: checkboxBodyFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: checkboxBodyVariantKeys,
  variantMap: checkboxBodyVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, checkboxBodyVariantKeys)
  },
  getVariantProps: checkboxBodyFn.getVariantProps,
})